module.exports = __webpack_public_path__ + "assets/img/my-patient-icon.ca91b19a.png";